import React from 'react'
import styles from './ProfileComplete.module.scss'
import FixedColorIcon, {
  FixedColorIcons,
} from '@crystal-eyes/components/elements/Icon/FixedColorIcon/FixedColorIcon'

export default function ProfileComplete({
  title,
  icon,
}: {
  title: string
  icon: FixedColorIcons
}) {
  return (
    <div className={styles.completenessBox}>
      <FixedColorIcon icon={icon} className={styles.browserIcon} />
      <FixedColorIcon
        icon={FixedColorIcons.CheckmarkGreenCircle}
        className={styles.checkmarkIcon}
      />
      <div className={styles.grayHeader}>{title}</div>
    </div>
  )
}
